// @ts-nocheck
import React from "react";
import rewardPointGrowthIcon from "../../assets/reward-points-growth-icon.svg"
import { ReactComponent as RewardAchivementStarIcon } from "../../assets/reward-achievement-star-icon.svg"
import rewardPointsStarIcon from "../../assets/reward-points-golden-star.svg"
import rewardCompletedCheckIcon from "../../assets/reward-completed-check-icon.svg"
import { Spin } from "antd";
import NoPermissionComponent from "modules/kudos-user/component/NoPermissionComponent";
import moment from "moment-timezone";

const RewardSystemOverviewView = (props) => {
  const { loading, overviewData, permission } = props;
  const {
    totalPoints,
    pointsForWeek,
    recentAchievements,
    overviewList
  } = overviewData;

  return (
    <Spin spinning={loading}>
      {permission && <div className="overview-view">
        <div className="reward-overview-container">
          <div className="reward-overview-main">
            <div className="reward-overview-points-card">
              <div className="reward-overview-points-label">Your Total Points</div>
              <div className="reward-overview-points-value">{totalPoints}</div>
              <div className="reward-overview-points-change">
                <img src={rewardPointGrowthIcon} alt="" />
                <span>+{pointsForWeek} this week</span>
              </div>
            </div>
            <div>
              <div className="reward-overview-ways-title">Ways to Earn Points</div>
              {Object.keys(overviewList).length > 0 && Object.entries(overviewList).map(([title, sections], index) => (
                <div key={index} className="reward-overview-earn-section">
                  <div className="reward-overview-earn-title">{title}</div>
                  <ul className="reward-overview-earn-list">
                    {sections.map(({ category, completed, points }, ii) => (
                      <li key={ii} className={`reward-overview-earn-item ${completed && "completed-reward"}`}>
                        <span>
                          <div className="check-icon-container">
                            {completed && <img src={rewardCompletedCheckIcon} alt="" />}
                          </div>
                          {category}
                        </span>
                        <span className="reward-overview-star-points">
                          <span className="reward-overview-star"><img src={rewardPointsStarIcon} alt="" /></span>{points} pts
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
          <div className="reward-overview-sidebar">
            <div className="reward-overview-achievements-card">
              <div className="reward-overview-achievements-title">Recent Achievements</div>
              <ul className="reward-overview-achievements-list">
                {recentAchievements.map(({ action, points, date }, index) => (
                  <li key={index} className="reward-overview-achievement-row">
                    <div className="reward-overview-achievement-info">
                      <RewardAchivementStarIcon className="achievement-img" />
                      <div>
                        <div className="reward-overview-achievement-title">{action}</div>
                        <div className="reward-overview-achievement-date">{date && moment(date).format('MMM DD, YYYY')}</div>
                      </div>
                    </div>
                    <div className="reward-overview-achievement-points"><img src={rewardPointsStarIcon} alt="" /> +{points}</div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>}
      {
        !loading && !permission && (
          <NoPermissionComponent />
        )
      }
    </Spin>
  );
}

export default RewardSystemOverviewView;